import { useState, useEffect, useCallback } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import axios from 'axios';
import { ArrowLeft, FolderKanban, Package, ChevronRight, FlaskConical } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL || ''}/api`;

export default function MobileRDPage() {
  const navigate = useNavigate();
  const [projects, setProjects] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchProjects = useCallback(async () => {
    try {
      const res = await axios.get(`${API}/rd/projects`);
      setProjects(res.data || []);
    } catch (err) {
      console.error('Failed to fetch R&D projects:', err);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchProjects();
  }, [fetchProjects]);

  if (loading) {
    return (
      <div className="mobile-page">
        <div className="mobile-loading"><div className="mobile-spinner" /></div>
      </div>
    );
  }

  return (
    <div className="mobile-page">
      <button className="mobile-back-btn" onClick={() => navigate('/mobile/more')}>
        <ArrowLeft size={18} /> More
      </button>

      <div className="mobile-page-title" style={{ marginBottom: 4 }}>R&D</div>
      <div className="mobile-page-subtitle" style={{ marginBottom: 16 }}>{projects.length} projects</div>

      {/* KPIs */}
      <div className="mobile-kpi-row">
        <div className="mobile-kpi-card purple">
          <div className="mobile-kpi-label">Projects</div>
          <div className="mobile-kpi-value">{projects.length}</div>
        </div>
        <div className="mobile-kpi-card blue">
          <div className="mobile-kpi-label">Active</div>
          <div className="mobile-kpi-value">{projects.filter(p => p.status === 'active' || p.status === 'in_progress').length}</div>
        </div>
      </div>

      {/* Projects List */}
      <div className="mobile-section-header">
        <span className="mobile-section-title">Projects</span>
      </div>

      {projects.length === 0 ? (
        <div className="mobile-empty-state">
          <FlaskConical />
          <p>No R&D projects found</p>
        </div>
      ) : (
        <div className="mobile-menu-list">
          {projects.map((project) => (
            <button
              key={project.project_id || project.id}
              className="mobile-menu-item"
              onClick={() => navigate(`/mobile/rd/projects/${project.project_id || project.id}`)}
            >
              <div className="mobile-menu-item-icon" style={{ background: '#5856d6' }}>
                <FolderKanban size={16} />
              </div>
              <div className="mobile-menu-item-content">
                <div className="mobile-menu-item-title">{project.name || project.project_name}</div>
                <div className="mobile-menu-item-subtitle">
                  {project.customer_name || 'No customer'}
                  {project.items_count ? ` · ${project.items_count} items` : ''}
                </div>
              </div>
              <ChevronRight size={16} className="mobile-menu-item-chevron" />
            </button>
          ))}
        </div>
      )}
    </div>
  );
}

export function MobileRDProjectsPage() {
  return <MobileRDPage />;
}
